import React from "react";

function UserInfoCard({ myRank, classified_rank }) {
  const { className, rank } = classified_rank;
  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "15px",
        borderRadius: "25px 25px 25px 25px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
        position: "fixed",
        bottom: "90px",
        left: "10px",
        right: "10px",
        zIndex: "1000",
        maxWidth: "600px",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          background: "#fbbf24",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "10px",
        }}
      >
        <span style={{ fontWeight: "bold", color: "#111827" }}>
          {myRank?.rank}
        </span>
      </div>

      <div style={{ textAlign: "left", marginLeft: "10px" }}>
        {/* <span
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            color: "#000",
            display: "block",
          }}
        >
          {myRank?.total_purchase}
        </span> */}
        <span
          style={{
            fontSize: "18px",
            fontWeight: "400",
            color: "#000",
            display: "block",
          }}
        >
          {myRank?.name}
        </span>
      </div>
      <div style={{ marginLeft: "auto", textAlign: "right" }}>
        <span
          style={{
            fontSize: "16px",
            color: "#000",
            display: "block",
            fontWeight: "bold",
          }}
        >
          {className} : {rank}
        </span>
      </div>
    </div>
  );
}

export default UserInfoCard;
